const projects = [
  {
    title: "Demo Dashboard",
    img: "https://res.cloudinary.com/robcg1102/image/upload/v1659391825/portfolio/ezgif-4-9e2809c973_qw0yil.gif",
    tools: ["React", "Material-UI", "Sass", "Material-Icons"],
    demo: "https://demo-mydashboard.netlify.app",
  },
  {
    title: "Demo E-commerce",
    img: "https://res.cloudinary.com/robcg1102/image/upload/v1619127591/portfolio/Multimedia1_o5sebm.gif",
    tools: [
      "React",
      "MongoDB",
      "Express",
      "Cloudinary",
      "React-Bootstrap",
      "Axios",
    ],
    demo: "https://ecommercerob.netlify.app/",
  },
  {
    title: "Apapacho",
    img: "https://res.cloudinary.com/robcg1102/image/upload/v1602710391/portfolio/Apapacho_effnxv.gif",
    tools: [
      "Javascript",
      "MongoDB",
      "CSS",
      "Express",
      "Handlebars",
      "Nodemailer",
    ],
    demo: "https://apapacho.herokuapp.com/",
  },
  {
    title: "Tattoo - Landing Page",
    img: "https://res.cloudinary.com/robcg1102/image/upload/v1598390493/portfolio/portfolio_MuerteInk_jr7mzt.gif",
    tools: ["React", "Express", "Nodemailer", "Remixicon"],
    demo: "https://muerteink.netlify.app/",
  },
  {
    title: "Wiki-countries",
    img: "https://res.cloudinary.com/robcg1102/image/upload/v1649197693/portfolio/wikicountries_twfmyq.gif",
    tools: ["React", "Redux", "Material UI", "API Countries"],
    demo: "https://mywiki-countries.netlify.app/",
  },
  {
    title: "Service Car",
    img: "https://res.cloudinary.com/robcg1102/image/upload/v1611971930/portfolio/serviceCar_d4jeki.gif",
    tools: ["React", "Typescript", "MongoDB", "Bootstrap", "Axios"],
    demo: "https://servicioauto.netlify.app/",
  },
  {
    title: "NBA APP",
    img: "https://res.cloudinary.com/robcg1102/image/upload/v1598390483/portfolio/portfolio_NBA_jpjqll.gif",
    tools: ["React", "Axios", "My own NBA-API", "CSS"],
    demo: "https://mynba-app.netlify.app/",
  },
  {
    title: "NBA-API",
    img: "https://res.cloudinary.com/robcg1102/image/upload/v1598390485/portfolio/portfolio_APINBA_muxysl.gif",
    tools: ["Javascript", "HTML5", "Express", "Handlebars", "MongoDB"],
    demo: "https://mynba-api.herokuapp.com/",
  },
];
export default projects;
